// Удалённые / тонкие посты → 301 на ближайший живой раздел.
// Единый источник для proxy (301-редиректы) и sitemap.js (исключение из sitemap):
// до 2026-07 слаги были захардкожены только в proxy, и sitemap продолжал
// публиковать 12 редиректящих URL (2×6) — «Страница с переадресацией» в GSC.
export const deletedBlogRedirects = {
    // tour-stubs <4k chars, давно не индексируются — 301 в /tours
    'durmitor-mountains-and-black-lake-tours-into-the-heart-of-montenegro-s-nature': 'montenegro/tours',
    'the-taste-of-the-country-wine-and-culinary-tours-in-montenegro': 'montenegro/tours',
    'one-day-trip-from-montenegro': 'montenegro/tours',
    // transport-stubs <4k chars — 301 в /transport
    'is-it-worth-booking-a-tour-with-transfer-in-montenegro-pros-and-cons': 'montenegro/transport',
    'private-transfer-or-taxi-what-s-the-best-option-for-tourists': 'montenegro/transport',

    // Дубликаты из пайплайна статей (SEO_AUDIT_2026-08-10, план п.9): пары почти
    // идентичных постов делили запросы. Канонический выбран по данным GSC 90д,
    // а не только по EN: у montenegro-prices выигрывает «-2026» — он длиннее
    // (11.5k против 8.5k знаков) и его RU-версия лучший добытчик пары
    // (25 кликов против 0); EN-вес «-in-2026» (1096 показов, поз. 5.9)
    // переезжает 301-м. Проигравшие остаются в Sanity — sitemap их фильтрует.
    'montenegro-prices-in-2026': 'blog/montenegro-prices-2026',
    'lake-skadar': 'blog/lake-skadar-virpazar',
    'telavi-kakheti-wine': 'blog/telavi-kakheti-wine-region',

    // Такого поста никогда не было, но Google показывает URL: 31 показ на позиции 2.8
    // в 09.2026 при ответе 404 (аудит 2026-09-16, §6).
    'qatar-for-tourists-what-you-cannot-do': 'blog/qatar-for-tourists-what-you-can-and-cannot-do',
};

const BLOG_HREF = /^(?:https?:\/\/(?:www\.)?triplinkhub\.com)?\/(en|ru)\/blog\/([^/?#]+)\/?(?:[?#].*)?$/i;

/**
 * Ссылка из текста или блока «Читайте также» на слаг с 301 → сразу конечный адрес.
 * В телах постов 96 ссылок вели на редиректящие слаги (аудит 2026-09-16): лишний хоп
 * для краулера и «Страница с переадресацией» вместо сигнала живой странице.
 */
export function resolveDeletedBlogHref(href) {
    if (typeof href !== 'string') return href;
    const match = href.match(BLOG_HREF);
    const dest = match && deletedBlogRedirects[match[2]];
    return dest ? `/${match[1].toLowerCase()}/${dest}` : href;
}
